import {
  ALLOWED_LABEL_NAV_ITEMS,
  COUNTERTOP_LABELS,
  FEATURES_WITH_0_VALUE_FOR_THE_SLABS,
  MEASURE_UNITS,
  SHAPE_PART_ID,
  SQFT_FEATURES,
} from "../../sqft/constants";
import {
  FEATURE_STONE,
  getFeatureType,
  getFeatureUnit,
  getSlabUnit,
  calculateStoneCost,
  getRoomName, getSlabsFeatureGroup
} from "../../../misc/helpers";
import {getCurrentLayout} from "../../appLayout";
import store from "../../../store";
import sqftShapeManager from "../../sqft/components/canvas/store/sqftShapeManager";
import workspace from "../../sqft/components/canvas/core/workspace";
import {getCommonVisualizerType} from "../../../config";
import {getNavItemsFromTheWizard, getWizardGroupsFromTheWizard} from "../../sqft/helpers/sqftHelperUi";
import sqftConfig from "../../sqft/components/canvas/store/sqftConfig";
import {
  groupedDataInControllers, QUANTITY_GROUP,
  WORKSPACE_CONTROLLERS_THAT_WILL_ADD_FEATURES
} from "../../sqft/components/canvas/store/workspaceControllers";
//import {isFeatureUnitUseEach} from "../../sqft/helpers/featureHelper";

/**
 * @param parentKey {string}
 * @param partId {string}
 * @param quoteIndex {number || null}
 * @returns featureGroup {object}
 */
export const getSimilarFeatureGroup = (parentKey, partId, quoteIndex = null) => {
  const state = store.getState();
  const quotes = state.quotesState.quotes;
  let room;
  let qtCategoryName;
  if (quoteIndex !== null && quotes[quoteIndex].room) {
    const activeQuote = quotes[quoteIndex];
    room = activeQuote.room;
    qtCategoryName = quotes[quoteIndex].qtCatName ? quotes[quoteIndex].qtCatName : getRoomNameInQuote(quoteIndex);
  }
  const layout = getCurrentLayout(room);
  if (!layout) {
    return null
  }

  let featureGroup = null;
  let neededPartId = partId;
  switch (parentKey) {
    case "backsplashes": {
      const isBathroom = getCommonVisualizerType() === "bathroom";
      featureGroup = layout.getSubPartFromQtCategories("backsplash", qtCategoryName, true);
      if (!featureGroup && isBathroom) {
        featureGroup = layout.getSubPartFromQtCategories(SQFT_FEATURES.vanity_backsplash, qtCategoryName);
      }
      neededPartId = isBathroom ? SQFT_FEATURES.vanity_backsplash : "backsplash";
      break;
    }
    case "edges": {
      const mainNeeded = parentKey === "center_island_countertop" ? "center_island_edge" : "edge_profile";
      const oppositeNeeded = mainNeeded === "center_island_edge" ? "edge_profile" : "center_island_edge";
      featureGroup = layout.getSubPartFromQtCategories(mainNeeded, qtCategoryName);
      if (!featureGroup) {
        featureGroup = layout.getSubPartFromQtCategories(oppositeNeeded, qtCategoryName);
      }
      neededPartId = mainNeeded;
      break;
    }
    case SQFT_FEATURES.slabs: {
      featureGroup = getSlabsFeatureGroup();
      // let countertopsCategory = layout.qtCategories.find(qtCategory => {
      //   return qtCategory.name === "Countertops" || qtCategory.name === "Countertop"
      // });
      //countertopsCategory = countertopsCategory === undefined ? layout.qtCategories[0] : countertopsCategory;

      //let subParts = countertopsCategory.subParts;
      //const subPartSlab = subParts.find(designNavigationItem => designNavigationItem.part.partId === SQFT_FEATURES.slabs);
      //if (!subPartSlab) {
        //subParts.splice(2, 0, featureGroup);
        //countertopsCategory.subParts = subParts;
      //}

      break;
    }
    case "countertop":
    case "center_island_countertop": {
      const oppositeNeeded = partId === "center_island_countertop" ? "countertop" : "center_island_countertop";
      featureGroup = layout.getSubPartFromQtCategories(partId, qtCategoryName);
      if (!featureGroup) {
        featureGroup = layout.getSubPartFromQtCategories(oppositeNeeded, qtCategoryName);
      }
      break;
    }
    case "corners": {
      featureGroup = layout.getSubPartFromQtCategories(partId, qtCategoryName);
      if (!featureGroup) {
        featureGroup = layout.getSubPartFromQtCategories('radius', qtCategoryName);
      }
      break;
    }
    default:
      featureGroup = layout.getSubPartFromQtCategories(partId, qtCategoryName);
      break;
  }
  if (!featureGroup) {
    const foundGroup = layout.getFeatureGroupByPartId(neededPartId);
    if (foundGroup) {
      featureGroup = {part: foundGroup}
    }
  }
  return featureGroup
};

/**
 * @returns {string}
 */
export const getRoomNameInQuote = (quoteIndex) => {
  const state = store.getState();
  const {quotes} = state.quotesState;
  const fabricatorData = state.fabricatorState;
  const cartItems = state.cartState.cartItems;
  const intl = workspace.intl;

  return getRoomName(quoteIndex, cartItems, quotes, intl.messages, intl.locale, fabricatorData);
}

/**
 * @param {{}} parentsList
 * @returns {boolean}
 */
export const isRecalculateSlabNeeded = (parentsList) => {
  const useStonePricing = Object.keys(parentsList).some(parentKey => {
    if (!parentsList[parentKey] || !parentsList[parentKey].features) {
      return false
    }
    return parentsList[parentKey].features.some((sqftFeature) => {
      if (sqftFeature && sqftFeature.feature && (FEATURE_STONE === getFeatureType(sqftFeature.feature.dbFeature))) { // dbFeature stone pricing algorithms related
        const {serverState, fabricatorState, cartState} = store.getState();
        // here we are checking if we should calculate algorithm or not
        // (if not - it should be counted as a regular feature, so it should be no grouping and included logic then)
        const stoneCost = calculateStoneCost(
          sqftFeature.feature.dbFeature,
          sqftFeature.initialQuantity,
          serverState.stonePricing,
          fabricatorState.stoneSupplier,
          false,
          fabricatorState.settings,
          cartState,
        );
        return !!stoneCost;
      }
      return false
    })
  })
  const useSlabImagePricing = parentsList.slabs.features.length > 0;

  return useStonePricing || useSlabImagePricing
}

/**
 * @param parentList {object}
 * @param firstOpen {boolean}
 * @returns sqftFeatures {object}
 */
export const recalculateSlabs = (parentList, firstOpen = false) => {
  const state = store.getState();
  const fabricatorSettings = state.fabricatorState.settings;
  let updatedParentList;
  if (fabricatorSettings.useCategorySwitching) {
    updatedParentList = splitPriceBetweenSlabsMaterial(parentList); // will divide total price between shapes
  } else {
    updatedParentList = setPriceIntoSingleFeature(parentList, firstOpen); // will display included price
  }

  return updatedParentList;
};

/**
 * @param sqftFeatures {object}
 * @param firstOpen {boolean}
 * @returns sqftFeatures {object}
 */
export const setPriceIntoSingleFeature = (sqftFeatures, firstOpen = false) => {
  let commonSharedFeatureNames = getCommonSharedFeatureNames(sqftFeatures); // {sharedName: "", totalQuantity: 0, biggestFeature, sqftFeatures: []}
  if (commonSharedFeatureNames.length) {  // 2) set each feature new fake quantity
    commonSharedFeatureNames.forEach(sharedObject => {
      sharedObject.sqftFeatures.forEach(sqftFeature => {
        const {fabricatorState} = store.getState();
        if (fabricatorState.isCaesarStone) {
          if (firstOpen) {
            if (sharedObject.biggestFeature && (sqftFeature.sqftId === sharedObject.biggestFeature.sqftId)) {
              sqftFeature.sortOrder = 1;
            } else {
              sqftFeature.sortOrder = 0;
            }
          }
        } else {
          //QCDES-1507 calculates slab algorithm pricing
          sqftFeature.displayFakeQuantity = sqftFeature.initialQuantity; // removed for CAESARSTONE, don't know about the others
          if (sharedObject.biggestFeature && (sqftFeature.sqftId === sharedObject.biggestFeature.sqftId)) {
            sqftFeature.quantity = sharedObject.totalQuantity; // removed for CAESARSTONE, don't know about the others
            if (firstOpen) {
              sqftFeature.sortOrder = 1;
            }
            sqftFeature.isBiggestFeature = true;
          } else {
            // removed for CAESARSTONE, don't know about the others
            sqftFeature.quantityRounded = 0;
            sqftFeature.quantity = 0;
            sqftFeature.isQuantityAddedToBiggestFeature = true;
            if (firstOpen) {
              sqftFeature.sortOrder = 0;
            }
          }
        }
      });
    });
    if (firstOpen) {
      sqftFeatures = sortSqftFeatures(sqftFeatures);
    }
  }
  console.log("commonSharedFeatureNames", commonSharedFeatureNames);
  return sqftFeatures
};

const createSqftFeaturesObj = () => {
  let sqftFeaturesObj = {};
  for (const availablePartIdsKey in SQFT_FEATURES) {
    sqftFeaturesObj[availablePartIdsKey] = {
      subPart: null,
      features: []
    }
  }

  return sqftFeaturesObj;
}

/**
 * @param sqftFeatures {object}
 * @param firstOpen {boolean}
 * @returns sqftFeatures {object}
 */
export const splitPriceBetweenSlabsMaterial = (sqftFeatures, firstOpen = false) => {
  let commonSharedFeatureNames = getCommonSharedFeatureNames(sqftFeatures);
  if (commonSharedFeatureNames.length) {
    commonSharedFeatureNames.forEach(sharedObject => {
      sharedObject = sortSharedObject(sharedObject, firstOpen);
      updateSharedObjectWithGroupQuantity(sharedObject);
    });
    if (firstOpen) {
      sqftFeatures = sortSqftFeatures(sqftFeatures);
    }
  }
  console.log("commonSharedFeatureNames", commonSharedFeatureNames);
  return sqftFeatures
};

const sortSqftFeatures = (sqftFeatures) => {
  Object.keys(sqftFeatures).forEach(parentKey => {
    if (sqftFeatures[parentKey]
      && sqftFeatures[parentKey].features
      && parentKey !== "edges"
    ) {
      sqftFeatures[parentKey].features = sqftFeatures[parentKey].features.sort((a, b) => b.sortOrder - a.sortOrder);
    }
  })

  return sqftFeatures
}
/**
 * @return array of objects [{sharedName: string, totalQuantity: number, biggestFeature: feature, sqftFeatures: []}]
 */
const getCommonSharedFeatureNames = (sqftFeatures) => {
  let commonSharedFeatureNames = [];
  Object.keys(sqftFeatures).forEach(parentKey => { // 1) create common objects and find the biggest feature
    if (sqftFeatures[parentKey]
      && sqftFeatures[parentKey].features
      && parentKey !== "edges"
      && parentKey !== "slabs"
    ) {
      sqftFeatures[parentKey].features.forEach(sqftFeature => {
        if (sqftFeature.feature && Array.isArray(sqftFeature.feature.dbFeature.stonePricingId)
          && sqftFeature.feature.dbFeature.stonePricingId.length) {
          const alreadyAdded = commonSharedFeatureNames.find(sharedObject => {
            return sharedObject.sharedName === sqftFeature.feature.dbFeature.sharedFeatureName
          });
          if (!alreadyAdded) {
            commonSharedFeatureNames.push({
              sharedName: sqftFeature.feature.dbFeature.sharedFeatureName,
              totalQuantity: sqftFeature.disabled ? 0 : sqftFeature.initialQuantity,
              sqftFeatures: [sqftFeature],
              biggestFeature: sqftFeature.disabled ? null : sqftFeature,
            })
          } else {
            alreadyAdded.sqftFeatures.push(sqftFeature);
            if (!sqftFeature.disabled) {
              alreadyAdded.totalQuantity += sqftFeature.initialQuantity;
              if (!alreadyAdded.biggestFeature) {
                alreadyAdded.biggestFeature = sqftFeature;
              } else if (sqftFeature.feature.partId === "countertop") {
                if (alreadyAdded.biggestFeature.partId !== "countertop" || (alreadyAdded.biggestFeature.initialQuantity < sqftFeature.initialQuantity)) {
                  alreadyAdded.biggestFeature = sqftFeature;
                }
              } else if (sqftFeature.feature.partId === "center_island_countertop") {
                if ((alreadyAdded.biggestFeature.partId !== "countertop" && alreadyAdded.biggestFeature.partId !== "center_island_countertop")
                  || (alreadyAdded.biggestFeature.partId === "center_island_countertop" && alreadyAdded.biggestFeature.initialQuantity < sqftFeature.initialQuantity)) {
                  alreadyAdded.biggestFeature = sqftFeature;
                }
              } else if ((alreadyAdded.biggestFeature.partId !== "countertop") && (alreadyAdded.biggestFeature.partId !== "center_island_countertop")
                && alreadyAdded.biggestFeature.initialQuantity < sqftFeature.initialQuantity) { // backsplash
                alreadyAdded.biggestFeature = sqftFeature;
              }
            }
          }
        }
      })
    }
  });

  return commonSharedFeatureNames
}
/**
 * set group price foreach sqftFeature inside sharedObject
 * @param sharedObject {object}
 * @returns sharedObject {object}
 */
const updateSharedObjectWithGroupQuantity = (sharedObject) => {
  const quantityPerFeature = sharedObject.totalQuantity / sharedObject.sqftFeatures.length;
  sharedObject.sqftFeatures.forEach(sqftFeature => {
    const {fabricatorState} = store.getState();
    if (!fabricatorState.isCaesarStone) {
      sqftFeature.group = {
        quantityPerFeature: quantityPerFeature,
        totalFeaturesInGroup: sharedObject.sqftFeatures.filter(sqftFeature => !sqftFeature.disabled).length,
        totalQuantity: sharedObject.totalQuantity,
      }
    }
  });

  return sharedObject
}

/**
 * Returns sorted sharedObject
 * @param sharedObject {object}
 * @param firstOpen {boolean}
 * @returns sharedObject {object}
 */
const sortSharedObject = (sharedObject, firstOpen) => {
  sharedObject.sqftFeatures.forEach(sqftFeature => {
    if (firstOpen) {
      if (sharedObject.biggestFeature && (sqftFeature.sqftId === sharedObject.biggestFeature.sqftId)) {
        sqftFeature.sortOrder = 1;
      } else {
        sqftFeature.sortOrder = 0;
      }
    }
  });

  return sharedObject
}

/**
 * Returns needed for popup data
 * @param sqftPassedData {object} // it has sqftCalcData - data that comes from sqft
 * @param previouslyAddedSqftFeatures {object}
 * @param intl {object} // react intl instance
 * @param fabricatorData {object}
 * @param cartItems {array}
 * @param sqftFromFeature {object}
 * @param quoteIndex {number}
 * @param visualizerType {string}
 * @param stonePricing {object}
 * @returns sqftFeatures {object}
 */
export function getParsedSqftData(
  sqftPassedData,
  previouslyAddedSqftFeatures,
  intl,
  fabricatorData,
  cartItems,
  sqftFromFeature,
  quoteIndex,
  visualizerType,
  stonePricing,
) {
  let sqftFeatures = createSqftFeaturesObj();

  if (!sqftPassedData || !sqftPassedData.countertops) {
    return sqftFeatures;
  }

  const state = store.getState();
  const isSlabPricingEnabled = state.sqftSlabState.isSlabPricingEnabled;
  const layout = getCurrentLayout(visualizerType);

  Object.keys(sqftFeatures).forEach(parentKey => {
    let featuresPassed = [];
    let featuresPassedGroups = [];
    const isCountertop = parentKey === "countertop" || parentKey === "center_island_countertop";

    // Skip adding slab features if slab pricing is disabled;
    if (parentKey === SQFT_FEATURES.slabs && !isSlabPricingEnabled) {
      return;
    }

    if (isCountertop) {
      featuresPassed = prepareCountertopFeaturesPassed(sqftPassedData, layout, parentKey);
    } else if (parentKey === SQFT_FEATURES.slabs) {
      featuresPassed = prepareSlabFeaturesPassed(sqftPassedData.slabImagesTotalArea);
    } else if (parentKey === SQFT_FEATURES.edges || parentKey === SQFT_FEATURES.backsplashes) {
      const shapeType = parentKey === "edges" ? "edge" : "backsplash";
      featuresPassed = sqftPassedData.manualCalculate
        ? prepareEdgesAndBacksplashesManual(sqftPassedData, shapeType, featuresPassed)
        : prepareEdgesAndBacksplashes(sqftPassedData, shapeType, featuresPassed);
    } else if (parentKey === SQFT_FEATURES.crown_molding) {
      featuresPassed = prepareCrownMoldings(sqftPassedData, parentKey);
    } else if (Object.values(ALLOWED_LABEL_NAV_ITEMS).includes(parentKey)) {

      // cabinets color
      if (sqftConfig.shouldUseCabinetDoorsSQFT) {
        featuresPassed = prepareDefaultFeatureObjectGrouped(sqftPassedData.countertops, parentKey, 'relatedParentFeatureId');
        featuresPassed = updateQuantityFromShapeSubParts(featuresPassed, 'cabinetDoorsSQFT');
        featuresPassed = setRelatedParentFeatureAsMain(featuresPassed, true);
      } else if (sqftConfig.shouldUseCabinetDoorsLNFT) {
        featuresPassed = prepareDefaultFeatureObjectGrouped(sqftPassedData.countertops, parentKey, 'relatedParentFeatureId');
        featuresPassed = updateQuantityFromShapeSubParts(featuresPassed, 'cabinetDoorsLNFT');
        featuresPassed = setRelatedParentFeatureAsMain(featuresPassed, true);
      } else if (sqftConfig.shouldUseCabinetDoorsAndDrawersQuantity) {
        featuresPassedGroups = prepareCabinetDoorsAndDrawers(sqftPassedData, parentKey, 'relatedParentFeatureId');
      }

      // cabinets boxes
      if (sqftConfig.shouldAddCabinetBoxes) {
        featuresPassed = [...featuresPassed, ...prepareDefaultFeatureObject(sqftPassedData.countertops, parentKey)];
      }
    } else if (parentKey === SQFT_FEATURES.radius) {
      featuresPassed = prepareDefaultFeatureObject(sqftPassedData.radii, parentKey);
    } else if (parentKey === SQFT_FEATURES.corners) {
      featuresPassed = prepareDefaultFeatureObject(sqftPassedData.corners, parentKey);
    } else if (parentKey === SQFT_FEATURES.underlayment && sqftPassedData.underlayment && sqftPassedData.underlayment.sections) {
      featuresPassed = prepareDefaultFeatureObject(sqftPassedData.underlayment.sections, parentKey);
    } else if (parentKey === SQFT_FEATURES.bumpouts && sqftPassedData.bumpouts) {
      featuresPassed = sqftPassedData.bumpouts;
    } else if ((parentKey === SQFT_FEATURES.top_handle || parentKey === SQFT_FEATURES.bottom_handle)
      && sqftPassedData.controllers && sqftPassedData.controllers.handles
    ) {
      featuresPassedGroups = prepareHandles(sqftPassedData, parentKey);
    } else if (WORKSPACE_CONTROLLERS_THAT_WILL_ADD_FEATURES.includes(parentKey)
      && sqftPassedData.controllers && sqftPassedData.controllers[parentKey]
    ) {
      if (groupedDataInControllers.includes(parentKey)) {
        featuresPassed = prepareDefaultFeatureObjectGrouped(sqftPassedData.controllers[parentKey], parentKey);
      } else {
        featuresPassed = prepareDefaultFeatureObject(sqftPassedData.controllers[parentKey], parentKey);
      }
    }

    featuresPassed.forEach(featurePassed => {
      const preparedFeature = prepareSQFTFeatures({
        featurePassed, parentKey, quoteIndex, layout, sqftPassedData,
        cartItems, isCountertop, previouslyAddedSqftFeatures, sqftFromFeature,
        intl, fabricatorData
      });

      if (!preparedFeature) return;

      const targetKey = featurePassed.targetParentKey || parentKey;

      if (!sqftFeatures[targetKey]) sqftFeatures[targetKey] = {};
      sqftFeatures[targetKey].features = sqftFeatures[targetKey].features || [];
      sqftFeatures[targetKey].features.push(preparedFeature);

      if (!sqftFeatures[targetKey].subPart) {
        sqftFeatures[targetKey].subPart = preparedFeature.subPart;
      }
    });

    if (featuresPassedGroups.length > 0) {
      const groupMap = {}; // { [targetKey]: { featuresSubGroups: [], subPart } }

      featuresPassedGroups.forEach(group => {
        group.featuresPassed.forEach(featurePassed => {
          const preparedFeature = prepareSQFTFeatures({
            featurePassed, parentKey, quoteIndex, layout, sqftPassedData,
            cartItems, isCountertop, previouslyAddedSqftFeatures, sqftFromFeature,
            intl, fabricatorData
          });

          if (!preparedFeature) return;

          const targetKey = featurePassed.targetParentKey || parentKey;

          if (!groupMap[targetKey]) {
            groupMap[targetKey] = {
              featuresSubGroups: [],
              subPart: null
            };
          }

          let groupEntry = groupMap[targetKey].featuresSubGroups.find(g => g.groupTitle === group.groupTitle);

          if (!groupEntry) {
            groupEntry = {
              groupTitle: group.groupTitle,
              features: []
            };
            groupMap[targetKey].featuresSubGroups.push(groupEntry);
          }

          groupEntry.features.push(preparedFeature);

          if (!groupMap[targetKey].subPart) {
            groupMap[targetKey].subPart = preparedFeature.subPart;
          }
        });
      });

      Object.entries(groupMap).forEach(([targetKey, data]) => {
        if (!sqftFeatures[targetKey]) sqftFeatures[targetKey] = {};
        sqftFeatures[targetKey].featuresSubGroups = data.featuresSubGroups;
        sqftFeatures[targetKey].subPart = data.subPart;
      });
    }
  });

  if (isSlabPricingEnabled && isRecalculateSlabNeeded(sqftFeatures)) {
    sqftFeatures = recalculateSlabs(sqftFeatures, true);
    console.log("stonePricing", stonePricing);
    console.log("fabricatorData.pricingPreset", fabricatorData.pricingPreset);
  }

  console.log("sqftFeatures", sqftFeatures);
  return sqftFeatures;
}

function prepareSQFTFeatures(props) {
  const {featurePassed, parentKey, quoteIndex, layout, sqftPassedData, cartItems,  previouslyAddedSqftFeatures,
    sqftFromFeature, intl, fabricatorData, isCountertop} = props;

  const relatedParentFeature = featurePassed.relatedParentFeatureId
    ? layout.getFeatureById(featurePassed.relatedParentFeatureId)
    : null;
  const effectivePartId = featurePassed.shouldUseRelatedParentFeatureAsMain && relatedParentFeature
    ? relatedParentFeature.partId
    : parentKey;
  const featureGroup = getSimilarFeatureGroup(effectivePartId, effectivePartId, quoteIndex);

  if (featureGroup) {
    const quantity = getQuantityFromCalculator(effectivePartId, featurePassed, sqftPassedData);
    const displayFakePrice = getFakePriceFromCalculator(effectivePartId, featurePassed, sqftPassedData, cartItems, quoteIndex);
    let [feature, isSqftFromFeature, fromWizardGroupId] = getFeatureFromSQFT(featurePassed,
      previouslyAddedSqftFeatures,
      featureGroup,
      parentKey,
      quoteIndex,
      isCountertop,
      sqftFromFeature,
      cartItems,
      layout,
    );
    const displayFakeQuantity = effectivePartId === SQFT_FEATURES.slabs ? featurePassed.totalSlabs : null;
    const displayFakeFeatureGroupName = effectivePartId === SQFT_FEATURES.slabs ? SQFT_FEATURES.slabs : null;
    const featureToCheckUnit = feature || featureGroup.part.features[0];
    const featureUnit = featureToCheckUnit ? getFeatureUnit(featureToCheckUnit, intl, fabricatorData, quantity) : "";
    const unit = effectivePartId === SQFT_FEATURES.slabs ? getSlabUnit(featurePassed.totalSlabs, intl) : featureUnit;
    sqftShapeManager.setShapeFeature(featurePassed.id, feature);

    return {
      disabled: featurePassed.isDisabledInPopup || false, //previouslyAddedSqftFeature ? previouslyAddedSqftFeature.disabled : false,
      feature: featurePassed.shouldUseRelatedParentFeatureAsMain && relatedParentFeature
        ? relatedParentFeature
        : feature,
      partId: effectivePartId,
      relatedParentFeature,
      shouldUseRelatedParentFeatureAsMain: featurePassed.shouldUseRelatedParentFeatureAsMain,
      displayFakeFeatureGroupName,
      unit,
      subPart: featureGroup,
      //quantity: isFeatureUnitUseEach(feature) ? 1 : quantity,
      quantity: quantity,
      quantityRounded: Math.ceil(quantity),
      displayFakeQuantity: displayFakeQuantity,
      quantityGroup: featurePassed.quantityGroup,
      displayFakePrice,
      initialQuantity: quantity,
      sqftId: featurePassed.id,
      sqftIds: featurePassed.ids,
      sqftQuantities: featurePassed.sqftQuantities,
      qtCatName: featurePassed.qtCatName,
      isSqftFromFeature,
      fromWizardGroupId,
      shouldShowEyeBall: featurePassed.shouldShowEyeBall !== undefined ? featurePassed.shouldShowEyeBall : true,
      shouldUseSlabPricing: featurePassed.shouldUseSlabPricing,
    };
  }

  console.log("No feature group added for", parentKey, featurePassed.partId);
  return null;
}

/**
 * Returns prepared slabFeatures that comes from sqft
 * @param slabImagesGrouped {object} // data that comes from sqft
 * @returns featuresPassed [array]
 */
const prepareSlabFeaturesPassed = (slabImagesGrouped) => {
  let featuresPassed = [];
  slabImagesGrouped
    .forEach(slabImagesGroup => {
      const quantity = Math.ceil(slabImagesGroup.totalArea);
      featuresPassed.push(Object.assign({...slabImagesGroup}, {
        partId: SQFT_FEATURES.slabs,
        squareFeet: quantity,
        pricePerArea: slabImagesGroup.pricePerArea,
        shouldUseSlabPricing: slabImagesGroup.shouldUseSlabPricing,
      }));
    });

  return featuresPassed;
}

/**
 * Returns prepared countertops that comes from sqft
 * @param sqftPassedData {object} // data that comes from sqft
 * @param layout {object} // layout
 * @param parentKey {string} // parentKey
 * @returns featuresPassed [array]
 */
const prepareCountertopFeaturesPassed = (sqftPassedData, layout, parentKey) => {
  const countertopExist = layout.getSubPartFromQtCategories("countertop");
  const centerIslandExist = layout.getSubPartFromQtCategories("center_island_countertop");
  let featuresPassed = []
  if (sqftPassedData.manualCalculate) {
    featuresPassed = sqftPassedData.countertops
      .filter(manCountertopObject => manCountertopObject.partId === parentKey)
      .map(manCountertopObject => {
        return {
          id: manCountertopObject.id,
          squareFeet: manCountertopObject.area,
          partId: manCountertopObject.partId
        }
      })
  } else if (sqftPassedData.countertops && sqftPassedData.countertops.length) {
    featuresPassed = sqftPassedData.countertops.filter(shape => {
      if (shape.partId === "countertop" || shape.partId === "center_island_countertop") {
        if (countertopExist && !centerIslandExist) {
          shape.partId = countertopExist.part.partId;
        } else if (centerIslandExist && !countertopExist) {
          shape.partId = centerIslandExist.part.partId;
        }
      }

      return shape.shapeType && (shape.partId === parentKey)
        && !["backsplash", SHAPE_PART_ID.seamPiece, SHAPE_PART_ID.slabPlaceHolder].includes(shape.type)
    })
  }

  return featuresPassed;
}

const prepareHandles = (sqftPassedData, parentKey) => {
  const handlesForDoors = sqftPassedData.controllers.handles.filter(handlesModel => handlesModel.quantityGroup === QUANTITY_GROUP.doors);
  const handlesForDrawers = sqftPassedData.controllers.handles.filter(handlesModel => handlesModel.quantityGroup === QUANTITY_GROUP.drawers);
  const featuresPassedForDoors = prepareDefaultFeatureObjectGrouped(handlesForDoors, parentKey);
  const featuresPassedForDrawers = prepareDefaultFeatureObjectGrouped(handlesForDrawers, parentKey);

  let result = [];
  if (featuresPassedForDoors && featuresPassedForDoors.quantity) {
    result.push({
      groupTitle: "Doors",
      featuresPassed: featuresPassedForDoors
    })
  }

  if (featuresPassedForDrawers && featuresPassedForDrawers.quantity) {
    result.push({
      groupTitle: "Drawers",
      featuresPassed: featuresPassedForDrawers
    })
  }

  return result
}

const prepareCabinetDoorsAndDrawers = (sqftPassedData, parentKey) => {
  let featuresPassedDoors = prepareDefaultFeatureObjectGrouped(sqftPassedData.countertops, parentKey, 'relatedParentFeatureId');
  featuresPassedDoors = setRelatedParentFeatureAsMain(featuresPassedDoors, true);
  featuresPassedDoors = updateQuantityFromShapeSubParts(featuresPassedDoors, 'doors');
  let featuresPassedDrawers = prepareDefaultFeatureObjectGrouped(sqftPassedData.countertops, parentKey, 'relatedParentFeatureId');
  featuresPassedDrawers = setRelatedParentFeatureAsMain(featuresPassedDrawers, true);
  featuresPassedDrawers = updateQuantityFromShapeSubParts([...featuresPassedDrawers], 'drawers');

  let result = [];
  if (featuresPassedDoors && featuresPassedDoors.length) {
    result.push({
      groupTitle: "Doors",
      featuresPassed: featuresPassedDoors
    })
  }

  if (featuresPassedDrawers && featuresPassedDrawers.length) {
    result.push({
      groupTitle: "Drawers",
      featuresPassed: featuresPassedDrawers
    })
  }

  return result
}

/**
 * Returns other dataObjects that comes from sqft
 * @param sqftPassedDataHandler {object} // data that comes from sqft
 * @param parentKey {string}
 * @returns featuresPassed [array]
 */
const prepareDefaultFeatureObject = (sqftPassedDataHandler, parentKey) => {
  return sqftPassedDataHandler
    .filter(passedObject => passedObject.partId === parentKey)
    .map(passedObject => {
      return {
        id: passedObject.id,
        partId: passedObject.partId,
        featureId: passedObject.featureId,
        relatedParentFeatureId: passedObject.relatedParentFeatureId,
        qtCatName: passedObject.qtCatName,
        quantity: passedObject.quantity,
        squareFeet: passedObject.squareFeet,
      }
    });
}

/**
 * Returns other dataObjects that comes from sqft
 * @param sqftPassedDataHandler {object} // data that comes from sqft
 * @param parentKey {string}
 * @param groupByKey {string} // key to group by (e.g., 'featureId' or 'relatedParentFeatureId')
 * @returns featuresPassed [array]
 */
const prepareDefaultFeatureObjectGrouped = (sqftPassedDataHandler, parentKey, groupByKey = 'featureId') => {
  const filteredData = sqftPassedDataHandler
    .filter(passedObject => passedObject[groupByKey] !== null && passedObject.partId === parentKey);

  const groupedByKey = filteredData.reduce((acc, passedObject) => {
    const groupKey = passedObject[groupByKey];
    const { id, quantity, squareFeet, quantityInGroup, quantitySubParts, ...rest } = passedObject;

    if (!acc[groupKey]) {
      acc[groupKey] = {
        ...rest,
        [groupByKey]: groupKey,
        ids: [],
        sqftQuantities: {},
        quantity: 0,
        quantityInGroup: 0,
        squareFeet: 0, //todo remove squareFeet and use only quantity
        quantitySubParts: {},
        sqftQuantitySubParts: {},
      };
    }

    acc[groupKey].ids.push(id);
    acc[groupKey].quantity += quantity || 0;
    acc[groupKey].squareFeet += squareFeet || 0;
    acc[groupKey].quantityInGroup += quantityInGroup || 0;
    acc[groupKey].sqftQuantities[id] = quantity || 0;
    acc[groupKey].sqftQuantitySubParts[id] = quantitySubParts || 0;

    if (quantitySubParts && typeof quantitySubParts === 'object') {
      Object.entries(quantitySubParts).forEach(([key, value]) => {
        acc[groupKey].quantitySubParts[key] = (acc[groupKey].quantitySubParts[key] || 0) + value;
      });
    }

    return acc;
  }, {});

  // Apply rounding to quantity
  return Object.values(groupedByKey).map(group => {
    const roundedQuantitySubParts = {};
    for (const [key, value] of Object.entries(group.quantitySubParts)) {
      roundedQuantitySubParts[key] = Math.ceil10(value, -2);
    }

    return {
      ...group,
      quantity: Math.ceil10(group.quantity, -2),
      squareFeet: Math.ceil10(group.squareFeet, -2),
      quantitySubParts: roundedQuantitySubParts,
      shouldShowEyeBall: false,
    };
  });
};
const updateQuantityFromShapeSubParts = (featuresPassed, quantitySubPartName) => {
  const updateSqftQuantities = (sqftQuantities, sqftQuantitySubParts, quantityKey) => {
    for (const key in sqftQuantities) {
      if (
        sqftQuantitySubParts[key] &&
        typeof sqftQuantitySubParts[key][quantityKey] === 'number'
      ) {
        sqftQuantities[key] = sqftQuantitySubParts[key][quantityKey];
      }
    }
    return sqftQuantities;
  };

  return featuresPassed
    // remove features with 0 quantity
    .filter(featurePassed => {
      const quantity = featurePassed.quantitySubParts ? featurePassed.quantitySubParts[quantitySubPartName] : 0;
      return quantity !== 0 && quantity !== undefined;
    })
    .map(featurePassed => {
      const quantity = featurePassed.quantitySubParts[quantitySubPartName];
      featurePassed.quantity = quantity;
      featurePassed.squareFeet = quantity;
      featurePassed.sqftQuantities = updateSqftQuantities(featurePassed.sqftQuantities, featurePassed.sqftQuantitySubParts, quantitySubPartName);

      return featurePassed;
    });
};

const setRelatedParentFeatureAsMain = (featuresPassed, shouldUseRelatedParentFeatureAsMain) => {
  for (const featurePassed of featuresPassed) {
    featurePassed.shouldUseRelatedParentFeatureAsMain = shouldUseRelatedParentFeatureAsMain;
    featurePassed.targetParentKey = featurePassed.parentPartId;
  }

  return featuresPassed
}

/**
 * Parse quantity from sqft // todo rewrite and remove this
 * @param parentKey {object} // data that comes from sqft
 * @param featurePassed {object} // data that comes from sqft
 * @param sqftPassedData {object} // data that comes from sqft
 * @returns featuresPassed [array]
 */
const getQuantityFromCalculator = (parentKey, featurePassed, sqftPassedData) => {
  let quantity;
  switch (parentKey) {
    case "edges":
    case "backsplashes":
    case SQFT_FEATURES.crown_molding:
      quantity = sqftPassedData.measureUnit === MEASURE_UNITS.Metric
        ? +(+(featurePassed.length).toFixed(3)).toFixed(2)
        : featurePassed.length
      break
    case SQFT_FEATURES.radius:
    case SQFT_FEATURES.corners:
    case SQFT_FEATURES.handle:
    case SQFT_FEATURES.underlayment:
      quantity = featurePassed.quantity;
      break
    case "countertop":
    case "center_island_countertop":
    case "slabs":
      quantity = featurePassed.squareFeet;
      break
    default:
      if (Object.keys(COUNTERTOP_LABELS).includes(parentKey)) {
        quantity = featurePassed.squareFeet;
      } else {
        quantity = featurePassed.quantity ? featurePassed.quantity : featurePassed.squareFeet;
      }
  }

  return quantity
}

/**
 * Prepare Edges and Backsplashes from sqft
 * @param sqftPassedData {object} // data that comes from sqft
 * @param shapeType {string}
 * @param featuresPassed {array}
 * @returns featuresPassed [array]
 */
const prepareEdgesAndBacksplashes = (sqftPassedData, shapeType, featuresPassed) => {
  sqftPassedData.countertops
    .filter(shape => shape.type === shapeType)
    .forEach(edge => {
      const length = edge.length || edge.squareFeet;
        featuresPassed.push(Object.assign(
          edge, {
          partId: edge.partId || shapeType,
          fromWizardGroupId: edge.fromWizardGroupId, //todo[Anton] this one is not passing here
          length: length,
          qtCatName: edge.qtCatName,
          featureId: edge.backsplashFeatureId ? edge.backsplashFeatureId : edge.featureId,
          shouldShowEyeBall: edge.shouldShowEyeBall !== undefined ? edge.shouldShowEyeBall : true,
        }));
    });

  return featuresPassed
}

/**
 * Prepare CrownMoldings from sqft
 * @param sqftPassedData {object} // data that comes from sqft
 * @param shapeType {string}
 * @returns featuresPassed [array]
 */
const prepareCrownMoldings = (sqftPassedData, shapeType) => {
  const featuresPassed = [];
  sqftPassedData.countertops
    .filter(shape => shape.type === shapeType)
    .forEach(crownMolding => {
      const length = crownMolding.length || crownMolding.squareFeet;
        featuresPassed.push(Object.assign(
          crownMolding, {
          partId: crownMolding.partId || shapeType,
          length: length,
          qtCatName: crownMolding.qtCatName,
        }));
    });

  return featuresPassed
}

/**
 * Prepare Edges and Backsplashes from sqft
 * @param sqftPassedData {object} // data that comes from sqft
 * @param shapeType {string}
 * @param featuresPassed {array}
 * @returns featuresPassed [array]
 */
const prepareEdgesAndBacksplashesManual = (sqftPassedData, shapeType, featuresPassed) => {
  let sqftData = [];
  switch (shapeType) {
    case "edge":
      sqftData = sqftPassedData.edges;
      break
    case "backsplash":
      sqftData = sqftPassedData.backsplashes;
      break
  }
  sqftData
    .forEach(edge => {
      const edgeLength = edge.length;
      const alreadyAdded = featuresPassed.find(addedEdge => {
        return addedEdge.attachedToParentId && (addedEdge.featureId === edge.featureId)
      });
      if (alreadyAdded) {
        alreadyAdded.length += edgeLength;
      } else {
        featuresPassed.push(Object.assign(edge, {featureId: edge.featureId, partId: edge.partId, length: edgeLength}));
      }
    });

  return featuresPassed
}

/**
 * //todo it is better to rewrite this fake price logic and calculate the price right in the cart
 * Get fake price for display
 * @param parentKey {object} // data that comes from sqft
 * @param featurePassed {object} // data that comes from sqft
 * @param sqftPassedData {object} // data that comes from sqft
 * @param cartItems
 * @param quoteIndex
 * @returns featuresPassed [array]
 */
const getFakePriceFromCalculator = (parentKey, featurePassed, sqftPassedData, cartItems, quoteIndex) => {
  let fakePrice ;
  /** If the number of slabs is greater than one, set the price of all other materials to zero, as only the cost of slabs will be calculated. */
  if (FEATURES_WITH_0_VALUE_FOR_THE_SLABS[parentKey]) {
    const slabAlreadyInTheCart = cartItems.find(cartItem => {
        return (cartItem.sqftId) && (cartItem.partId === SQFT_FEATURES.slabs) && (cartItem.currentQuote === quoteIndex)
      })
    const state = store.getState();
    const isSlabPricingEnabled = state.sqftSlabState.isSlabPricingEnabled;
    if ((sqftPassedData.slabImagesTotalArea.length > 0 || slabAlreadyInTheCart) && isSlabPricingEnabled) {
      const activeSlabsExist = sqftPassedData.slabImagesTotalArea.some(slabImageAreaGroup => !slabImageAreaGroup.isDisabledInPopup);
      if (activeSlabsExist) {
        fakePrice = 0;
      }
    }
  /** Applying the hardcoded price for slabs, which was set in the slab popup. */
  } else if (parentKey === SQFT_FEATURES.slabs) {
    if (featurePassed.pricePerArea) {
      fakePrice = parseFloat(featurePassed.pricePerArea) * getQuantityFromCalculator(parentKey, featurePassed, sqftPassedData);
    }
  }

  return fakePrice
}

/**
 * Returns parse sqft passed feature id and returns feature or null
 * @param featurePassed {object} // data that comes from sqft
 * @param parentKey {string} //
 * @param featureGroup {object} featureGroup
 * @param layout {object}
 * @returns feature {object}
 */
const getFeatureFromCalculatorPassedId = (featurePassed, parentKey, featureGroup, layout) => {
  let feature = null;
  let idToFind = null;
  switch (parentKey) {
    case "edges":
    case "backsplashes":
    case "countertop":
    case "center_island_countertop":
    case "slabs":
    case SHAPE_PART_ID.slabPlaceHolder:
      idToFind = +featurePassed.featureId;
      break
    default:
      idToFind = featurePassed.featureId ? featurePassed.featureId: null;
  }
  if (idToFind) {
    feature = layout.getFeatureById(idToFind, true);
    if (!feature && featurePassed.slabParentPartId) {
      const slabParentFeatureGroup = layout.getFeatureGroupByPartId(featurePassed.slabParentPartId);
      if (slabParentFeatureGroup) {
        feature = slabParentFeatureGroup.getFeatureById(featurePassed.featureId, true);
      }
    }
    if (!feature && featurePassed.partId) {
      const slabParentFeatureGroup = layout.getFeatureGroupByPartId(featurePassed.partId);
      if (slabParentFeatureGroup) {
        feature = slabParentFeatureGroup.getFeatureById(featurePassed.featureId, true);
      }
    }
    // const navFeatures = getNavItems(featureGroup);//layout.designNavigationItems(featureGroup, {}, "", false, true);
    //
    // const navFeature = navFeatures.find(navItem => navItem.part.dbFeature.id === idToFind);
    // if (navFeature) {
    //   feature = navFeature.part;
    // } else if (parentKey === "slabs") {
    //   feature = layout.getFeatureById(idToFind);
    // } else if (parentKey === "top_cabinet" || parentKey === "bottom_cabinet") {
    //   feature = layout.getFeatureById(idToFind, true);
    // }
  }

  return feature;
}

/**
 * Returns parse sqft passed feature id and returns feature or null
 * @param featurePassed {object} // data that comes from sqft
 // * @param previouslyAddedSqftFeatures {object} //
 * @param previouslyAddedSqftFeatures
 * @param featureGroup {object} //
 * @param parentKey {string} //
 * @param activeQuoteIndex {number} //
 * @param isCountertop {boolean} //
 * @param sqftFromFeature {object} //
 * @param cartItems {object} //
 * @param layout {object} //
 * @returns feature {object}
 */
const getFeatureFromSQFT = (
  featurePassed,
  previouslyAddedSqftFeatures,
  featureGroup,
  parentKey,
  activeQuoteIndex,
  isCountertop,
  sqftFromFeature,
  cartItems,
  layout,
) => {
  let isSqftFromFeature = false;
  const previouslyAddedSqftFeature = previouslyAddedSqftFeatures.find(existing => {
    return featurePassed.id && (existing.sqftId === featurePassed.id) && (existing.currentQuote === activeQuoteIndex)
  });
  let feature = getFeatureFromCalculatorPassedId(featurePassed, parentKey, featureGroup, layout);

  if (cartItems.length && !feature) {
    const alreadyAdded = cartItems.find(cartItem => {
      return (cartItem.sqftId) && (cartItem.sqftId === featurePassed.id) && (cartItem.currentQuote === activeQuoteIndex)
    })
    const hasSamePartIdWithCartFeature = alreadyAdded && featureGroup.part.partId === alreadyAdded.cartFeature.partId
    if (hasSamePartIdWithCartFeature) {
      feature = alreadyAdded.cartFeature;
    }
  }

  const hasSamePartIdWithPreviouslyAddedFeature = previouslyAddedSqftFeature && previouslyAddedSqftFeature.partId === featureGroup.part.partId
  if (!feature && hasSamePartIdWithPreviouslyAddedFeature) {
    feature = previouslyAddedSqftFeature.feature;
  }
  if (!feature && (isCountertop || parentKey === "backsplashes") && sqftFromFeature
    && (sqftFromFeature.cartFeature.partId === featureGroup.part.partId)) {
    feature = sqftFromFeature.cartFeature;
  }

  const state = store.getState();
  const {wizardActiveItem, wizardIsActive} = state.wizardState;

  let fromWizardGroupId = featurePassed.fromWizardGroupId;

  if (!fromWizardGroupId && wizardIsActive && wizardActiveItem) {
    const featureGroup = layout.getFeatureGroupByPartId(featurePassed.partId);
    if (featureGroup) {
      const wizardSteps = getWizardGroupsFromTheWizard(featureGroup.dbName || featureGroup.partName);
      if (wizardSteps.length) {
        // we don't set it to featurePassed, as we need to have all navItems in the dropdown, here we just find
        // at least something from the wizard
        fromWizardGroupId = wizardSteps[0].stepGroups[0].id;
      }
    }
  }

  const allNavItems = fromWizardGroupId
    ? getNavItemsFromTheWizard(featureGroup, "", {}, fromWizardGroupId)
    : layout.designNavigationItems(featureGroup, {}, "", false, true);

  // console.log("allNavItems", allNavItems);

  if (!feature && sqftFromFeature && (
    ((parentKey === "backsplashes") && sqftFromFeature.cartFeature.partId.includes("countertop"))
    || (isCountertop && sqftFromFeature.cartFeature.partId.includes("backsplash"))
    || (isCountertop && sqftFromFeature.cartFeature.partId.includes("countertop")
      && featureGroup.part.partId !== sqftFromFeature.cartFeature.partId) // case if 2 countertops
  )) {
    const name1 = sqftFromFeature.cartFeature.getSplittedFeatureName();
    const navItem = allNavItems.find(navItem => {
      return navItem.part.getSplittedFeatureName() === name1;
    });
    if (navItem) {
      feature = navItem.part;
    }
  }
  if (!feature && featureGroup.part.activeFeature && (!fromWizardGroupId || allNavItems.some(navItem => {
    return navItem.part.dbFeature.sharedFeatureName === featureGroup.part.activeFeature.dbFeature.sharedFeatureName
  }))) {
    feature = featureGroup.part.activeFeature;
  }
  if (!feature && featurePassed.featureId) {
    // we added a real feature with id - go and find it - cases when we load feature from different visualizer
    const allNavItems2 = layout.designNavigationItems(featureGroup, {}, "", false, "all", [], {returnAllFeatures: true});
    const foundNavItem = allNavItems2.find(nItem => nItem.part.dbFeature.id === featurePassed.featureId);
    if (foundNavItem) {
      feature = foundNavItem.part;
    }
  }
  if (!feature && allNavItems.length) {
    feature = allNavItems[0].part;
  }

  return [feature, isSqftFromFeature, featurePassed.fromWizardGroupId];
}
